var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_138",
    "data-name": "Groupe 138",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.356,
    height: 22.73,
    viewBox: "0 0 24.356 22.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_136",
    "data-name": "Groupe 136",
    transform: "translate(0 7.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_162",
    "data-name": "Trac\\xE9 162",
    d: "M7.293,26.488H1.812A.812.812,0,0,1,1,25.676V12.145a.812.812,0,0,1,.812-.812H7.293a.812.812,0,0,1,.812.812V25.676A.812.812,0,0,1,7.293,26.488ZM2.624,24.864H6.481V12.957H2.624Z",
    transform: "translate(-1 -11.333)",
    fill: "#19c3b9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_137",
    "data-name": "Groupe 137",
    transform: "translate(5.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_163",
    "data-name": "Trac\\xE9 163",
    d: "M17.892,24.732h-4.6a7.4,7.4,0,0,1-4.4-1.459l-.816-.608a.811.811,0,0,1-.327-.651V10.389a.806.806,0,0,1,.1-.4l3.712-6.625A2.513,2.513,0,0,1,13.112,2.1a2.545,2.545,0,0,1,2.015.267,2.518,2.518,0,0,1,1.215,2.363l-.375,4.847h7.179a3.479,3.479,0,0,1,3.327,4.5c-.421,1.2-2.509,7.112-3.39,8.193A6.669,6.669,0,0,1,17.892,24.732ZM9.375,21.606l.49.365a5.779,5.779,0,0,0,3.428,1.137h4.6a5.05,5.05,0,0,0,3.93-1.867,57.207,57.207,0,0,0,3.107-7.673A1.858,1.858,0,0,0,23.145,11.2H15.089a.811.811,0,0,1-.809-.874L14.722,4.6A.91.91,0,0,0,13,4.127L9.375,10.6Z",
    transform: "translate(-7.751 -2.002)",
    fill: "#19c3b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.7aec1b879abeede8d38e1bd8ed8de9a5.svg";
export { ForwardRef as ReactComponent };